import {Box, Center, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {INVOICE_FORM_MAX_WIDTH} from '../constants';

type InvoicePageProps = {
  children?: ReactNode;
};

export const InvoicePage = (props: InvoicePageProps) => (
  <Box backgroundColor="palettes.neutral.20.100" width="100%" minHeight="100%">
    <Center>
      <Box width={INVOICE_FORM_MAX_WIDTH} padding={4}>
        <VStack spacing={4}>{props.children}</VStack>
      </Box>
    </Center>
  </Box>
);
